class ConsentManager {
    static #defaultPreferences = {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
        functionality_storage: 'denied',
        personalization_storage: 'denied',
        security_storage: 'denied',
    };

    static #consentOptions = [
        'granted',
        'denied'
    ];

    static #cookieName = 'consent_preferences';

    static initializePreferences() {
        window.consentPreferences = this.#getPreferences();
        gtag('consent', 'default',
            window.consentPreferences
        );
        gtag('set', 'url_passthrough', true);
    }

    static initializeForm() {
        const consentForm = document.querySelector('.consent-preferences-form');
        const consentCustomize = document.querySelector('.consent-customize');

        document.querySelector('#consent-button-accept-all').addEventListener('click', event => {
            this.#acceptAll();
            consentForm.classList.add('hide');
        });
        document.querySelector('#consent-button-essential-only').addEventListener('click', event => {
            this.#acceptEssentialOnly();
            consentForm.classList.add('hide');
        });
        document.querySelector('#consent-button-customize').addEventListener('click', event => {
            consentCustomize.classList.remove('hide');
        });
        document.querySelector('#consent-button-confirm').addEventListener('click', event => {
            consentForm.classList.add('hide');
            consentCustomize.classList.add('hide');
            let preferences = {};
            document.querySelectorAll('.consent-type [data-consenttype]:enabled').forEach(element => {
                const consentTypes = element.dataset.consenttype.split(',');
                if (consentTypes) {
                    consentTypes.forEach(consentType => {
                        if (consentType) {
                            const consentOption = element.checked ? 'granted' : 'denied';
                            preferences[consentType] = consentOption;
                        }
                    });
                }
            });
            this.#updateConsent(preferences);
        });
        document.querySelector('#close-customize').addEventListener('click', event => {
            consentCustomize.classList.add('hide');
        });
        document.querySelectorAll('.consent-type-heading').forEach(element => {
            element.addEventListener('click', event => {
                if (!event.target.matches('.consent-type-toggle') && !event.target.closest('.consent-type-toggle')) {
                    const iconElement = element.closest('.consent-type').querySelector('.consent-type-icon');
                    const descriptionElement = element.closest('.consent-type').querySelector('.consent-type-description');
                    if (iconElement.classList.contains('open')) {
                        iconElement.classList.remove('open');
                        descriptionElement.classList.add('hide');
                    } else {
                        iconElement.classList.add('open');
                        descriptionElement.classList.remove('hide');
                    }
                }
            });
        });
        document.querySelector('#consent-preferences-link').addEventListener('click', event => {
            consentCustomize.classList.remove('hide');
        });
    }

    static showForm() {
        const consentForm = document.querySelector('.consent-preferences-form');
        consentForm.classList.remove('hide');
    }

    static #getPreferences() {
        let preferences = {};
        let preferencesFromCookie = this.#getConsentCookie();
        Object.keys(this.#defaultPreferences).forEach(consentType => {
            const validConsentOption = this.#consentOptions.find(
                consentOption => consentOption === (preferencesFromCookie[consentType] || 'denied')
            );
            preferences[consentType] = validConsentOption || this.#defaultPreferences[consentType];
        });
        return preferences;
    }

    static #updateConsent(preferences) {
        Object.keys(preferences).forEach(consentType => {
            if (!this.#defaultPreferences.hasOwnProperty(consentType)) {
                throw "Invalid consent type provided. Expected one of: ["+Object.keys(this.#defaultPreferences).toString()+"]";
            }
            const validConsentOptions = [
                'granted',
                'denied'
            ];
            if (!validConsentOptions.includes(preferences[consentType])) {
                throw "Invalid consent option provided. Expected one of: ["+validConsentOptions.toString()+"]";
            }
            window.consentPreferences[consentType] = preferences[consentType];
            //Update toggles
            document.querySelectorAll('.consent-type [data-consenttype]:enabled').forEach(element => {
                let checked = true;
                const consentTypes = element.dataset.consenttype.split(',');
                if (consentTypes) {
                    consentTypes.forEach(consentTypeInput => {
                        if (window.consentPreferences[consentTypeInput] !== 'granted') {
                            checked = false;
                        }
                    });
                }
                element.checked = checked;
            });
        });

        this.#setConsentCookie(window.consentPreferences, 365);
        //Push preferences to GTM
        //Note that previewing a website with Tag Assistant may not always show the updated preferences under 
        //the "Consent Update" event, so use a test tag configured with required consent type(s) to verify instead.
        gtag('consent', 'update',
            window.consentPreferences
        );
    }

    static #acceptAll() {
        let preferences = {};
        Object.keys(this.#defaultPreferences).forEach(consentType => {
            preferences[consentType] = 'granted';
        });
        this.#updateConsent(preferences);
    }

    static #acceptEssentialOnly() {
        let preferences = {};
        Object.keys(this.#defaultPreferences).forEach(consentType => {
            preferences[consentType] = 'denied';
        });
        this.#updateConsent(preferences);
    }

    static #setConsentCookie(preferences, expirationDays) {
        const value = encodeURIComponent(JSON.stringify(preferences));
        const d = new Date();
        const expirationSeconds = expirationDays * 24 * 60 * 60;
        let cookieString = this.#cookieName + '=' + value + '; max-age=' + expirationSeconds + '; path=/; SameSite=Lax';

        document.cookie = cookieString;
    }

    static #getConsentCookie() {
        const match = document.cookie.match(
            new RegExp('(^|;\\s*)' + this.#cookieName + '=([^;]*)')
        );

        const value = match ? decodeURIComponent(match[2]) : null;
        const preferences = JSON.parse(value);
        return preferences || {};
    }

}

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

ConsentManager.initializePreferences();

window.addEventListener("DOMContentLoaded", () => {
    ConsentManager.initializeForm();
});